<template>
  <div>
    <div class="row">
      <div class="offset-6 col-6 text-right">
        <div>
          <button
            class="btn btn-sm btn-primary"
            @click="$router.push({ name: 'add-new-contract' })"
          >
            新增契約
          </button>
          <button
            class="btn btn-primary btn-sm"
            @click="$router.push({ name: 'policyInfo' })"
          >
            回到保單列表
          </button>
        </div>
      </div>
    </div>
    <section v-if="!isLoading">
      <!-- ---------國泰人壽壽險--------- -->
      <cathay-life-insurance-for-edit
        :datas="getCathayInsuranceResult"
        :_fields="fieldOption.ACTION_ONE"
        ref="cathay-life-insurance-for-edit"
      >
      </cathay-life-insurance-for-edit>
      <other-life-insurance-for-edit
        :datas="getOtherInsuranceResult.otherinfo"
        :_fields="fieldOption.ACTION_DROPDOWN"
        ref="other-life-insurance-for-edit"
      >
      </other-life-insurance-for-edit>

      <product-suggest-for-edit
        :datas="getOtherInsuranceResult.suggestinfo"
        :_fields="fieldOption.ACTION_ONE"
        ref="product-suggest-for-edit"
      >
      </product-suggest-for-edit>
      <!-- ---------國泰人壽保單--------- -->

      <!-- ---------國泰人壽壽險--------- -->
      <!-- ---------國泰人壽團險--------- -->

      <!-- ---------國泰人壽團險--------- -->
      <!-- ---------國泰人壽產險--------- -->
      <property-insurance 
        :showNoDataMsg="false"
        :isEdit="true"
        :isLoading="isPropertyLoading"
        :allFamilyDatas="allFamilyDatas"
        :cathayHealthInsurance="cathayHealthInsurance"
        :cathayHurtInsurance="cathayHurtInsurance"
        :cathayNewInsurance="cathayNewInsurance"
        :cathayCarInsurance="cathayCarInsurance"
        :cathayFireInsurance="cathayFireInsurance"
        :otherInsuranceNote="otherInsuranceNote"
        :otherNewInsurance="otherNewInsurance"
        :otherCarInsurance="otherCarInsurance"
        :otherFireInsurance="otherFireInsurance"
        ref="property-insurance"
      ></property-insurance>
      <other-property-insurance 
        :showNoDataMsg="false"
        :isEdit="true"
        :isLoading="isPropertyLoading"
        :allFamilyDatas="allFamilyDatas"
        :cathayHealthInsurance="cathayHealthInsurance"
        :cathayHurtInsurance="cathayHurtInsurance"
        :cathayNewInsurance="cathayNewInsurance"
        :cathayCarInsurance="cathayCarInsurance"
        :cathayFireInsurance="cathayFireInsurance"
        :otherInsuranceNote="otherInsuranceNote"
        :otherNewInsurance="otherNewInsurance"
        :otherCarInsurance="otherCarInsurance"
        :otherFireInsurance="otherFireInsurance"
        ref="other-property-insurance"
      ></other-property-insurance>
      
      <!-- ---------國泰人壽產險--------- -->
      <message
        v-if="!hasData && !isAllLoading && !isPropertyLoading"
        message="此家戶尚未有任何保單"
      />
      <message
        v-else-if="hasData && !editDataCheck && !isAllLoading && !isPropertyLoading"
        message="此家戶無可編輯保單"
      />
    </section>
    <message
      class="mt-5 d-flex justify-content-center"
      v-else
      loading
      message="資料讀取中，請稍候..."
    />
    <confirm-modal />
  </div>
</template>

<script>
import PolicyListMixins from "./PolicyList";
import ConfirmModal from "@/desktop/components/ConfirmModal";

export default {
  mixins: [PolicyListMixins],
  components: {
    ConfirmModal,
  },
  data() {
    return { editDataCheck: false };
  },
  computed: {
    fieldOption() {
      const ACTION_INIT_OPTION = {
        key: "action",
        name: "編輯",
        className: "text-center",
        thClassName: "text-center",
      };
      return {
        ACTION_ONE: { ...ACTION_INIT_OPTION, width: 80 },
        ACTION_DROPDOWN: { ...ACTION_INIT_OPTION, width: 30 },
      };
    },
  },
  watch: {
    isPropertyLoading() {
      this.showCheck();
    },
  },
  methods: {
    setHighLightTag(dataList, modify) {
      if (!dataList || dataList.length == 0 || !modify || modify.length == 0) {
        return;
      }
      dataList.forEach((element) => {
        if (modify.includes(element.pt_contractx_id || element.ceplcno)) {
          element.trClassName = "bg-orange";
        }
      });
    },
    showCheck() {
      if (this.hasData) {
        let haveData = false;
        haveData = this.$refs["property-insurance"].hasPropertyInsurance;

        if (!haveData) {
          let componentsRefArray2 = [
            "cathay-life-insurance-for-edit",
            "other-life-insurance-for-edit",
            "product-suggest-for-edit",
          ];
          componentsRefArray2.map((e) => {
            if (this.$refs[e] && this.$refs[e].proccessDatas.length > 0) {
              haveData = true;
            }
          });
        }
        this.editDataCheck = haveData;
      }
    },
  },
  mounted() {
    if (this.$route.query.modify) {
      const timer = setInterval(() => {
        const $addFirst = window.$(".bg-orange:first");
        if ($addFirst.length) {
          window
            .$("html, body")
            .animate(
              { scrollTop: $addFirst.offset().top - 100 },
              400,
              "linear"
            );
          clearInterval(timer);
        }
      }, 300);
    }
    this.showCheck();
  },
  updated() {
    this.showCheck();
  },
};
</script>
